export const FEATURES = [
  {
    id: "shortener",
    tabName: "Shorten",
    title: "Shortener",
    tagline: "Link Shortening & Sharing Made Easy.",
    description:
      "Transform long URLs into memorable short links, generate & download QR codes and track your links with comprehensive analytics.",
    route: "/shortener",
    keyFeatures: [
      "Customize short URLs",
      "Download QR codes in multiple formats (PNG, SVG)",
      "Track link performance with view counts and usage trends",
      "Keep track of every short link with a simple, centralized URL library",
    ],
  },
  {
    id: "linkhub",
    tabName: "LinkHub",
    title: "LinkHub",
    tagline: "All Your Links in One Place.",
    description:
      "Create a centralized all-in-one LinkHub with custom branding and manage all your important URLs behind one single, unified link.",
    route: "/my-link-hub",
    keyFeatures: [
      "Create a branded all-in-one link collection",
      "Manage multiple links behind a single unified link",
      "Share LinkHub via one short URL or QR Code",
      "Comprehensive analytics for each link",
    ],
  },
  {
    id: "wifi",
    tabName: "Wi-Fy",
    title: "Wi-Fy",
    tagline: "Simplify Your WiFi Connection.",
    description:
      "Generate QR codes for instant WiFi access. No more typing long passwords - just scan and connect seamlessly.",
    route: "/wifiqr",
    keyFeatures: [
      "Support for all encryption types",
      "Download in multiple formats (PNG, SVG)",
      "Perfect for businesses and events",
      "Professional CGI branding",
    ],
  },
] as const;
